import { render, staticRenderFns } from "./scroe.vue?vue&type=template&id=4f8dfaa6&scoped=true"
import script from "./scroe.vue?vue&type=script&lang=js"
export * from "./scroe.vue?vue&type=script&lang=js"
import style0 from "./scroe.vue?vue&type=style&index=0&id=4f8dfaa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8dfaa6",
  null
  
)

export default component.exports